<template>
  <CommonLsitPage
    dataUrl="/exhibition/page"
    :params="pageParams"
    ref="tableRef"
  ></CommonLsitPage>
  <el-dialog v-model="dialogVisible" title="确认操作" width="30%">
    <span
      >此操作将删除
      <span style="color: red">{{ exhibitionDetail.ArticleTitle }}</span
      >，请谨慎操作。</span
    >
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="danger" @click="deleteExhibitionFunction"
          >删除</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import CommonLsitPage from '../../../components/common-list-page.vue'
import moment from '../../../utils/moment'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
// import { BASE_HOST } from '../../../utils/axios'
import { ElMessage } from 'element-plus'
import { deleteExhibition } from '../../../apis'

import { Delete, Edit, Tickets } from '@element-plus/icons-vue'

const tableRef = ref(null)
const dialogVisible = ref(false)

const router = useRouter()
// const route = useRoute()
const exhibitionDetail = ref({})
const pageParams = {
  title: '展览管理',
  btns: [
    {
      type: 'primary',
      name: '发布展览',
      onClick: () => {
        router.push({
          name: 'adminExhibitionOperation'
        })
      }
    }
  ],
  // <el-table-column prop="date" label="Date" width="180" />
  tableColumn: [
    {
      label: '发布时间',
      prop: 'Pubtime',
      sortable: 'custom',
      width: 200,
      formatter: (row, column, cellValue, index) => {
        const str = moment(cellValue).format('YYYY-MM-DD  hh:mm:ss')
        // console.log(str)
        return str
      }
    },

    {
      prop: 'ArticleTitle',
      label: '展览名称'
    },
    {
      label: '展览类型',
      prop: 'ArticleSort',
      // sortable: 'custom',
      filters: [
        { text: '本馆展览', value: 98 },
        { text: '其他展览', value: 99 }
      ],
      width: 200,
      formatter: (row, column, cellValue, index) => {
        const key = { 98: '本馆展览', 99: '其他展览' }
        const str = key[cellValue]
        // console.log(str)
        return str
      }
    },
    {
      label: '展览时间',
      prop: 'Honor'
      // width: 150
    },
    {
      prop: 'AddUser',
      label: '发布者'
    },

    {
      label: '操作',
      width: 240,
      operations: [
        {
          name: '查看',
          // type: 'plain',
          icon: Tickets,
          onClick: (scope) => {
            const exhibitionDetailPage = router.resolve({
              name: 'exhibitionDetail',
              query: { id: scope.row.Id }
            })

            window.open(exhibitionDetailPage.href, '_blank')

            // exhibitionDetail.value = scope.row
            // showDrawer.value = true
          }
        },
        {
          name: '编辑',
          type: 'success',
          icon: Edit,
          onClick: (scope) => {
            // console.log(tableRef.value.refresh())
            console.log(scope.row.Id, 1111)

            router.push({
              path: '/admin/exhibition/operation',
              query: {
                id: scope.row.Id
              }
            })
          }
        },
        {
          name: '删除',
          type: 'danger',
          icon: Delete,

          onClick: (scope) => {
            exhibitionDetail.value = scope.row
            dialogVisible.value = true
            console.log(scope, 1111)
          }
        }
      ]
    }
  ]
}

const deleteExhibitionFunction = () => {
  deleteExhibition(exhibitionDetail.value.Id).then((res) => {
    tableRef.value.refresh()
    // console.log(res, '删除数据')
    dialogVisible.value = false
    ElMessage({
      message: '删除成功',
      type: 'success'
    })
  })
}
</script>

<style scoped lang="scss">
.cell-item {
  width: 6em;
}
.dec-box {
  // background: red;
}
</style>
